import Colors from "assets/Colors";
import styled from "styled-components";

const Container = styled.div`
  // .esnPQU .ant-select-disabled {
  //   color: '#fff' !important;
  // }

  .ant-select-selector {
    margin-left: 0px;
    border: 1px solid
      ${(props) => props.borderColor || Colors.background_dividers} !important;
    box-shadow: none !important;
    // font-weight: 300;
    font-size: 12px;
    line-height: 14px;
    border-radius: 2px !important;
  }
  ${(props) =>
    props.right == "view" &&
    `
.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector::after, .ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-item, .ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-placeholder {
  line-height: 38px;
  justify-content: end;
  display: flex;
}
`}
`;

const textOption = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  line-height: 24px;
  font-weight: 400;
`;

export default {
  Container,
  textOption,
};
